// Utility helpers to persist selected zone id across admin navigation + refresh.
// Uses sessionStorage so it clears on browser tab close. Fallback to in‑memory variable if storage unavailable.

let memoryZoneId = null;
const KEY = 'activeZoneId';

export function setActiveZoneId(zoneId) {
  try {
    if (zoneId) {
      sessionStorage.setItem(KEY, zoneId);
      memoryZoneId = zoneId;
    }
  } catch (_) {
    memoryZoneId = zoneId; // fallback
  }
}

export function getActiveZoneId() {
  try {
    const fromStorage = sessionStorage.getItem(KEY);
    return fromStorage || memoryZoneId;
  } catch (_) {
    return memoryZoneId;
  }
}

export function clearActiveZoneId() {
  try { sessionStorage.removeItem(KEY); } catch(_) {}
  memoryZoneId = null;
}
